import { defineStore } from 'pinia';
import { computed } from 'vue';

import { dashboardBffClient } from '@/api-client';
import type { JoinConfig } from '@/api-client/api';
import { useApiRequest } from '@/composables/useApiRequest';

export const useSecondaryStore = defineStore('secondary', () => {
  // No cacheTimeout: join-status polling relies on every call returning fresh data.
  const {
    requestPromise: fetchMcInfo,
    forcefullyRequestPromise: forceFetchMcInfo,
    response: mcInfo,
  } = useApiRequest(dashboardBffClient.mc.getMcInfo, {
    transformResponse: (res) => res.data,
  });
  const isJoining = computed(() => mcInfo.value?.joinStatus?.status === 'joining');
  const isRejected = computed(() => mcInfo.value?.joinStatus?.status === 'rejected');
  const primaryIngress = computed(() => mcInfo.value?.joinStatus?.joinConfig?.primaryIngress);

  async function joinCluster(config: JoinConfig) {
    await dashboardBffClient.mc.joinCluster(config);
  }

  const { requestPromise: deleteJoinConfig, isPending: deleteJoinConfigIsPending } = useApiRequest(
    dashboardBffClient.mc.deleteJoinConfig,
  );

  const { requestPromise: setupPrimary, isPending: setupPrimaryIsPending } = useApiRequest(
    dashboardBffClient.mc.setupPrimary,
  );

  return {
    mcInfo,
    fetchMcInfo,
    forceFetchMcInfo,
    isJoining,
    isRejected,
    primaryIngress,
    joinCluster,
    deleteJoinConfig,
    deleteJoinConfigIsPending,
    setupPrimary,
    setupPrimaryIsPending,
  };
});
